<template>
  <div class="ind_foo_kefu" @click="beian">
  		<img class="kefu_img" src="../../static/img/qq_kefu.png"/>
  		<div class="keft_text keft_text_th1">在</div>
  		<div class="keft_text">线</div>
  		<div class="keft_text">客</div>
  		<div class="keft_text">服</div>
  </div>
</template>

<script>
export default {
  name: 'kefu',
  data () {
    return {
      toggle:false
    }
  },
	methods: {
		beian: function(){
			var userAgentInfo = navigator.userAgent;
			var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
			var flag = true;
			for (var v = 0; v < Agents.length; v++) {
				if (userAgentInfo.indexOf(Agents[v]) > 0) {
					flag = false;
					break;
				}
			}
			if(flag){
				window.open('http://wpa.qq.com/msgrd?v=3&uin=535659836&site=qq&menu=yes&from=message&isappinstalled=0');
			}else{
				window.open('mqqwpa://im/chat?chat_type=wpa&uin=535659836&version=1&src_type=web');
			}
		}
	}
}
</script>

<style scoped>
.ind_foo_kefu{
	position:fixed;
	width:50px;
	height:148px;
	bottom:78px;
	right:0px;
	z-index:99999;
	box-sizing:border-box;
	background: #FFFFFF;
	box-shadow: 0px 0px 13px 0px rgba(73, 93, 109, 0.21);
	border-radius: 10px 0px 0px 10px;
	cursor:pointer;
}
.kefu_img{
	width:25px;
	height:30px;
	margin-top:20px;
}
.keft_text{
	width:100%;
	font-size: 14px;
	font-family: PingFang SC,PingFangSC-Medium,微软雅黑;
	font-weight: bold;
	color: #000000;
}
.keft_text_th1{
	margin-top:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Kefu.vue